// Avatar clicável com upload — no padrão Aeros (mockup "Modal Usuário
// Geral"): círculo de 56px com o selo de câmera sobreposto, sem botão
// separado. O clique em qualquer ponto abre o seletor de arquivo.
import React, { useContext, useState } from "react";
import Avatar from "@material-ui/core/Avatar";
import Tooltip from "@material-ui/core/Tooltip";
import { makeStyles } from "@material-ui/core/styles";
import PhotoCameraOutlinedIcon from "@material-ui/icons/PhotoCameraOutlined";
import { toast } from "react-toastify";

import { AuthContext } from "../../context/Auth/AuthContext";
import { getBackendUrl } from "../../config";
import { i18n } from "../../translate/i18n";
import { AEROS, stateText } from "../../styles/aerosTokens";

const backendUrl = getBackendUrl();

const ALLOWED_TYPES = [
  "image/jpeg",
  "image/jpg",
  "image/png",
  "image/gif",
  "image/webp",
];
const MAX_SIZE = 5 * 1024 * 1024; // 5MB

const useStyles = makeStyles((theme) => ({
  wrap: { position: "relative", flex: "none", lineHeight: 0 },
  avatar: ({ size }) => ({
    width: size,
    height: size,
    cursor: "pointer",
    border: `1px solid ${theme.palette.divider}`,
  }),
  badge: ({ size }) => ({
    position: "absolute",
    right: -4,
    bottom: -4,
    width: Math.max(20, Math.round(size * 0.39)),
    height: Math.max(20, Math.round(size * 0.39)),
    borderRadius: "50%",
    backgroundColor: theme.palette.aeros.surface,
    border: `1px solid ${
      theme.palette.type === "light"
        ? theme.palette.aeros.borderStrong
        : "rgba(255,255,255,0.15)"
    }`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    padding: 0,
    "& .MuiSvgIcon-root": {
      fontSize: 13,
      color: stateText(theme, AEROS.cyan, "info"),
    },
  }),
}));

const AvatarUploader = ({ setAvatar, avatar, companyId, size = 56 }) => {
  const classes = useStyles({ size });
  const [previewImage, setPreviewImage] = useState(null);
  const { user } = useContext(AuthContext);

  // Id único por instância evita que dois uploaders na mesma tela disputem
  // o mesmo input (o `id` fixo anterior fazia exatamente isso).
  const [inputId] = useState(
    () => `avatar-upload-${Math.random().toString(36).slice(2)}`
  );

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    if (!ALLOWED_TYPES.includes(file.type)) {
      toast.error(i18n.t("avatarUpload.invalidType"));
      return;
    }

    if (file.size > MAX_SIZE) {
      toast.error(i18n.t("avatarUpload.tooLarge"));
      return;
    }

    setAvatar(file);

    const reader = new FileReader();
    reader.onload = () => setPreviewImage(reader.result);
    reader.readAsDataURL(file);
  };

  const getImageSrc = () => {
    if (previewImage) return previewImage;
    if (avatar && companyId)
      return `${backendUrl}/public/company${companyId}/user/${avatar}`;
    return `${backendUrl}/public/app/noimage.png`;
  };

  const open = () => document.getElementById(inputId)?.click();

  return (
    <div className={classes.wrap}>
      <Avatar
        alt=""
        src={getImageSrc()}
        className={classes.avatar}
        onClick={open}
        onError={(e) => {
          e.target.src = `${backendUrl}/public/app/noimage.png`;
        }}
      />

      <input
        accept="image/*"
        type="file"
        id={inputId}
        style={{ display: "none" }}
        onChange={handleFileChange}
      />

      <Tooltip title={i18n.t("userModal.changePhoto")}>
        <button
          type="button"
          className={classes.badge}
          aria-label={i18n.t("userModal.changePhoto")}
          onClick={open}
        >
          <PhotoCameraOutlinedIcon />
        </button>
      </Tooltip>
    </div>
  );
};

export default AvatarUploader;
